import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface RecordPageViewRequest {
  pagePath: string;
  durationSeconds: number;
}

@Injectable({
  providedIn: 'root',
})
export class ChannelEngagementService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = environment.apiUrl;

  recordPageView(body: RecordPageViewRequest): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}CustomerEngagement/RecordPageView`, body);
  }
}
